<div class="content-wrapper d-print-none">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">Requests</h4>
          <div class="input-group-append">
            <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
          </div>
          <div class="table-responsive pt-3">
            <nz-table #contractTable [nzData]="Requests" [nzPageSize]="50">
              <thead>

                <tr>
                  <th>
                    #
                  </th>
                  <th>
                    Reference
                  </th>

                  <th>
                    Request Date
                  </th>
                  <th>
                    Request Type
                  </th>

                  <th *ngIf="showCreatedByColumn">
                    Created By
                  </th>

                  <th *ngIf="showFunctionColumn">
                    Function
                  </th>

                  <th>
                    Contractor
                  </th>

                  <th>
                    Status
                  </th>
                  <th>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of contractTable.data; let i = index ;" >

                  <td>
                    {{i+1}}
                  </td>
                  <td>
                    {{ data.reference }} <sup style="color: red; font-weight: bold;" *ngIf="data.expressApprovalRequired && data.poNumber == null && data.status == 'Active'">Pending PO Number</sup>
                  </td>

                  <td>
                    {{ data.createdDate | date: 'dd MMMM yyy' }}
                  </td>
                  <td>
                    {{ data.renewalOrNew }}
                  </td>

                  <td *ngIf="showCreatedByColumn">
                    {{data.createdBy}}
                  </td>

                  <td *ngIf="showFunctionColumn">
                    {{data.departmentName}}
                  </td>

                  <td>
                    {{data.contractorName}}
                  </td>

                  <td>
                    <button [ngClass]="getStatusColor(data.status)"> {{data.status}}</button>
                  </td>
                  <td>
                    
                    <div class="dropdown">
                      <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuIconButton6" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                       
                      </button>
                      <div class="dropdown-menu" aria-labelledby="dropdownMenuIconButton6">
               
                        <a class="dropdown-item" (click)="open(data)">View</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" (click)="openEmps(data.id, data.type)">View Employees</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" (click)="openPendingApprovals(data)">View Approvals</a>
                            <div class="dropdown-divider"></div>
                        <a class="dropdown-item"  nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                        (nzOnConfirm)="beginRenew(data)" (nzOnCancel)="cancel()" *ngIf="canRenewContract && data.status =='Closed'">Renew Request</a>

                        <a class="dropdown-item"   nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                        (nzOnConfirm)="beginClose(data)" (nzOnCancel)="cancel()" *ngIf="canRenewContract && data.status =='Active'">Close Request</a>

                        <a class="dropdown-item"   nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
                        (nzOnConfirm)="beginCancel(data)" (nzOnCancel)="cancel()" *ngIf="canCreateContract && (data.status=='New'|| data.status =='Pending')">Cancel Request</a>
                      </div>
                    </div>

                
                  </td>
                </tr>
              </tbody>
            </nz-table>

          </div>
        </div>
      </div>
    </div>


  </div>
</div>
<!-- Context Menu  -->
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item>1st menu item</li>
    <li nz-menu-item>2nd menu item</li>
    <li nz-menu-divider></li>
  </ul>
</nz-dropdown-menu>


<nz-drawer [nzBodyStyle]="{ overflow: 'auto' }" [nzMaskClosable]="false" [nzWidth]="1040"
  [nzVisible]="ViewRequestVisible" [nzFooter]="footerTpl" (nzOnClose)="close()">

  <!-- Side swipe content -->
  <div class="row d-print-block">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="row">
          <div  class="col">
            <h5 class="card-title"> Labour Request Details</h5>
          </div>
          <div  class="col">
            <img src="../../../assets/images/holcim_logo_color.svg" alt=""
            srcset="" style="height: 30px;">
          </div>
        </div>
      
       
        <div class="card-body">
          <div class="row">

            <div class="col">
              <label><b>Request Reference</b></label>
              <p>{{ UpdateRequest?.reference }}</p>
            </div>

            <div class="col">
              <label><b>Function</b></label>
              <p>{{ UpdateRequest?.departmentName }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Location</b></label>
              <p>{{ UpdateRequest?.locationName }}</p>
            </div>

            <div class="col">
              <label><b>Cost Center</b></label>
              <p>{{ UpdateRequest?.costCenterName }}</p>
            </div>
          </div>
        </div>

        <hr *ngIf="!editing">

        <!-- Non Editable View -->
        <div class="card-body" *ngIf="!editing">
          <div class="row">

            <div class="col">
              <label><b>Request Date</b></label>
              <p>{{ UpdateRequest?.createdDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Contract Duration (Month)</b></label>
              <p>{{ UpdateRequest?.contractDuration }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Expected Start Date</b></label>
              <p>{{ UpdateRequest?.expectedStartDate | date: 'dd MMMM yyyy' }}</p>
            </div>

            <div class="col">
              <label><b>Number of Staff Approved</b></label>
              <p>{{ UpdateRequest?.noOfStaff }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <label><b>Mode Of HeadCount </b></label>
              <p>{{ UpdateRequest?.modeOfHeadCount  }}</p>
            </div>

            <div class="col">
              <label><b> Active Number of Employees</b></label>
              <p>{{ UpdateRequest?.numberofActiveEmployees }}</p>
            </div>
          </div>


          <div class="row">

            <div class="col">
              <label><b>Budget Cost</b></label>
              <p>{{ UpdateRequest?.budgetCost | currency:"NGN":"symbol-narrow" }}</p>
            </div>

            <div class="col">
              <label><b>Requested By</b></label>
              <p>{{ UpdateRequest?.createdBy }}</p>
            </div>
          </div>

          <div class="row">

            <div class="col">
              <div class="form-group" *ngIf="(contractorId > 0)">
                <label><b>Contractor</b></label>
                <p>{{ UpdateRequest?.contractorName }}</p>
              </div>
            </div>

            <div class="col">
              <div class="form-group" *ngIf="(poNumber != null)">
                <label><b>PO Number</b></label>
                <p>{{ UpdateRequest?.poNumber }}</p>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group" >
                <label><b>Approved Cost</b></label>
                
                <p>{{ UpdateRequest?.approvedCost | currency:"NGN":"symbol-narrow" }}</p>
              </div>
            </div>

            <div class="col">
              <div class="form-group" >
                <label><b>Terminal Date</b></label>
                
                <p>{{ UpdateRequest?.endDate |  date: 'dd MMMM yyyy' }}</p>
              </div>



            </div>

          </div>
         
          <div class="row">
            <div class="col">
              <div class="form-group" >
                <label><b>Notes</b></label>
                
                <p>{{ UpdateRequest?.message}}</p>
              </div>
            </div>

            <div class="col" *ngIf="UpdateRequest?.closeDate != '0001-01-01T00:00:00' ">
              <div class="form-group" >
                <label><b>Closed Date</b></label>
                
                <p>{{ UpdateRequest?.closeDate |  date: 'dd MMMM yyyy' }}</p>
              </div>



            </div>

          </div>

          <div class="row">

            <div class="col">
              <label><b>Request Description</b></label>
              <p>{{ UpdateRequest?.description }}</p>
            </div>

            <div class="col">
              <label><b>Request Justification</b></label>
              <p>{{ UpdateRequest?.justification }}</p>
            </div>
          </div>



          
          <div class="row">

            <div class="col">
              <label><b>Required Qualification & Experience</b></label>
              <p>{{ UpdateRequest?.qualification }}</p>
            </div>

            <div class="col">
              <label><b>Safety Notes</b></label>
              <p>{{ UpdateRequest?.safetyInductionNotes }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <label><b>Medical Notes </b></label>
              <p>{{ UpdateRequest?.medicalNotes  }}</p>
            </div>
            <div class="col">
              <label><b>Axiom </b></label>
              <p>{{ UpdateRequest?.axiom  }}</p>
            </div>


          </div>
          <div class="row">
            <div class="col">
              <label><b>Request Type </b></label>
              <p>{{ UpdateRequest?.renewalOrNew  }}</p>
            </div>
            
          </div>
        </div>

        <hr>

        <!-- Approvals -->
        <div class="card-body" *ngIf="!editing">
          <h5 class="card-title">Approvals</h5>
          <div class="table-responsive" *ngIf="RequestApprovals?.length">
            <table class="table table--striped table-hover">
              <thead>
                <tr>

                  <th>
                    Approved By
                  </th>
                  <th>
                    Date Approved
                  </th>
                  <th>
                    Message
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let approval of RequestApprovals">

                  <td>{{approval.approvedBy}}</td>
                  <td>{{approval.dateOfApproval | date: 'dd MMMM yyyy hh:mm a'}}</td>
                  <td>{{approval.message}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="!RequestApprovals?.length"
            style="color: rgba(128, 128, 128, 0.741); text-align: center; padding: 18px;">
            <h4 style="color: rgba(128, 128, 128, 0.741);">No approval has been granted.</h4>
          </div>
          <!-- Approvals -->
        </div>
        <!-- Non Editable -->

        <!-- Editable view -->
        <div class="card-body d-print-none" *ngIf="canUpdatePO">

          <div class="row">

             <div class="col">
  <div class="form-group">
  <label><b>PO Number(s)</b></label>
  <input 
    type="text"
    class="form-control"
    id="poNumber"
    name="poNumber"
    [(ngModel)]="poNumber"
    minlength="4"
    maxlength="100"
    placeholder="Enter PO numbers separated by commas if you have multiple POs"
    pattern="^[0-9,]+$"
    title="Only numbers and commas are allowed"
  >
</div>

</div>
            <div class="col">
              <div class="form-group">
                <label><b>Contractor</b></label>
                    <ng-select  required [(ngModel)]="contractorId"  id="contractorId" name="contractorId">
                  <ng-option *ngFor="let vendor of Vendors" [value]="vendor.id">
                    <!-- {{vendor.name}} - {{vendor.contractorType}}</ng-option> -->
                    {{vendor.name}} </ng-option>
                </ng-select>


              </div>
            </div>

          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label><b>Approved Cost</b></label>
                <input type="number" class="form-control" id="approvedCost" name="approvedCost"
                  [(ngModel)]="approvedCost">
              </div>
            </div>
              <!-- Expected Start Date  -->
              <div class="col">
                <div class="form-group">
                  <label for="exampleInputCity1">Actual Start Date</label>
                  <input type="date" class="form-control" id="actualStartDate" placeholder="" name="actualStartDate"
                    min="{{ actualStartDate | date: 'yyyy-MM-dd' }}" [(ngModel)]="actualStartDate" required
                    #ActualStartDate="ngModel">
                  <div class="alert alert-danger" role="alert"
                    *ngIf="ActualStartDate.errors">
                    Date is required!
                  </div>
                </div>
              </div>
           
<!--
            <div class="col">
              <div class="form-group">
                <label><b>Biometrics Required?</b></label>
                <select class="form-control" required [(ngModel)]="biometricRequired" name="biometricRequired">
                  <option [ngValue]="false">No</option>
                  <option [ngValue]="true">Yes </option>
                </select>
              </div>
            </div>
          -->
          </div>

          <div class="row">
<!--
            <div class="col">
              <div class="form-group">
                <label><b>Medical Requirement</b></label>
                <textarea class="form-control" id="medicalNotes" rows="4" name="medicalNotes" [(ngModel)]="medicalNotes"
                  required> </textarea>
              </div>
            </div>
 -->
            <div class="col">
              <div class="form-group">
                <label><b>Safety Requirement</b></label>
                <textarea class="form-control" id="safetyInductionNotes" rows="4" name="safetyInductionNotes"
                  [(ngModel)]="safetyInductionNotes" required> </textarea>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label><b>Comment</b></label>
                <textarea class="form-control" id="comment" rows="4" name="comment"
                  [(ngModel)]="comment" required> </textarea>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label for="exampleInputCity1">PO Date</label>
                <input type="date" class="form-control" id="poDate" placeholder="" name="poDate"
                  min="{{ poDate | date: 'yyyy-MM-dd' }}" [(ngModel)]="poDate" required
                  #PoDate="ngModel">
                <div class="alert alert-danger" role="alert"
                  *ngIf="PoDate.errors">
                  Date is required!
                </div>
              </div>
            </div>

          </div>

       
          
          <!-- Editable View -->

        </div>
      </div>
    </div>
    <!-- Side swipe content -->

    <ng-template #footerTpl >
    <ng-container >
      <div style="float: right" class="d-print-none">
        <button class="btn btn-warning" style="margin-right: 8px;" (click)="update()"
         *ngIf="UpdateRequest?.status === 'Approved' || UpdateRequest?.status === 'Active'" >Update</button>

        <button class="btn btn-primary" style="margin-right: 8px;" (click)="beginEdit()"
        *ngIf="UpdateRequest?.status === 'Approved' || UpdateRequest?.status === 'Active'" >Update PO Number</button>

        <button class="btn btn-primary" style="margin-right: 8px;" (click)="print()"
          *ngIf="UpdateRequest?.status === 'Approved' || UpdateRequest?.status === 'Active' && showCreatedByColumn">Print</button>

        <button class="btn btn-light" style="margin-right: 8px;" style="margin-right: 8px;"
          (click)="close()">Close</button>
      </div>

      <!-- Express Approval button  -->
      <div style="float: left" class="d-print-none">
        <a nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
          (nzOnConfirm)="openExpressApprovalModal()" (nzOnCancel)="cancel()">
          <span style="margin-right: 8px;" class="btn btn-danger"
            *ngIf="canPrint && (poNumber == null) && !expressApprovalRequest">
            Request Express Approval
          </span>
        </a>
      </div>

      <!-- Terminate Request  
      <div style="float: left" class="d-print-none">
        <a nz-popconfirm nzPopconfirmTitle="Are you sure?" nzOkText="Yes" nzCancelText="Cancel"
          (nzOnConfirm)="openTerminate()" (nzOnCancel)="cancel()">
          <span style="margin-right: 8px;" class="btn btn-danger"
            *ngIf="canTerminate">
            Terminate Request
          </span>
        </a>
      </div>
       -->
      <div style="float: right" class="d-print-none"   *ngIf="canChangeEmp && UpdateRequest?.status === 'Active' && showCreatedByColumn">
        <a nz-popconfirm nzPopconfirmTitle="Are you sure? This will require approvals!" nzOkText="Yes"
          nzCancelText="Cancel" (nzOnConfirm)="openChangeNoModal()" (nzOnCancel)="cancel()">
          <span style="margin-right: 8px;" class="btn btn-dark btn-icon-text">
            Change No of Employees
            <i class="ti-file btn-icon-append"></i>  
          </span>
        </a>
      </div>
     </ng-container>
    </ng-template>
  </div>
</nz-drawer>

<!-- Change Number of Employee Modal  -->
<nz-modal [(nzVisible)]="isChangeNumVisible" nzTitle="Change Number of Employees" (nzOnCancel)="handleCancel()"
  (nzOnOk)="submitForm()" [nzOkLoading]="isChangeOkLoading">
  <form nz-form [formGroup]="newNumOfStaffForm" (ngSubmit)="submitForm()">

    <div class="row">

      <div class="col">
        <label><b>Current Approved Number </b></label>
        <p>{{ UpdateRequest?.noOfStaff  }}</p>
      </div>

      <div class="col">
        <label><b> Active Number of Employees</b></label>
        <p>{{ UpdateRequest?.numberofActiveEmployees }}</p>
      </div>
    </div>

    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzFor="numberOfStaff" nzRequired nzTooltipTitle="New Number of Employees">
        <span>Number of Staff</span>
      </nz-form-label>
      <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please enter No of Staff!">
        <input nz-input id="numberOfStaff" formControlName="numberOfStaff" class="formControl" type="number" />
      </nz-form-control>
    </nz-form-item>

    <nz-form-item>
      <nz-form-label [nzSpan]="7" nzFor="message" nzRequired nzTooltipTitle="Comment is mandatory">
        <span>Comment</span>
      </nz-form-label>
      <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please enter Comment!">

        <textarea formControlName="message" nz-input rows="2" placeholder="Comment" class="formControl"></textarea>
      </nz-form-control>
    </nz-form-item>


     
  </form>




</nz-modal>

<!-- Express Approval  Modal  -->
<nz-modal [(nzVisible)]="isExpressApprovalModalVisible" nzTitle="Express Approval" (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification">Comment</label>
      <textarea class="form-control" id="expressApprovalMessage" rows="4" name="expressApprovalMessage"
        [(ngModel)]="expressApprovalMessage" required></textarea>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="sendExpressApproval()" [disabled]="isChangeOkLoading">Submit</button>
  </div>

</nz-modal>

<!-- Close Request Modal  -->
<nz-modal [(nzVisible)]="isTerminationVisible" nzTitle={{terminateTitle}} (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Comment</b></label>
      <textarea class="form-control" id="terminationComment" name="terminationComment" [(ngModel)]="terminationComment"
        required>
      </textarea>
    </div>

  
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-danger" (click)="terminateRequest()" [disabled]="isChangeOkLoading">Terminate</button>
  </div>

</nz-modal>



<!-- Renew Contract modal  -->
<nz-modal [(nzVisible)]="isReneweModalVisible" nzTitle={{renewModalTitle}} (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Duration (Months)</b></label>
      <input  type="number" class="form-control" id="renewDuration" name="renewDuration" [(ngModel)]="renewDuration" required   (ngModelChange)="onchangeforEndDate($event)">
    </div>
  

    <div class="form-group">

      <label for="exampleInputCity1"><b>Start Date</b></label>
      <input type="date" class="form-control" id="renewStartDate" placeholder="" name="renewStartDate"  (ngModelChange)="onchangeforEndDate($event)"
        [(ngModel)]="renewStartDate" required>
    </div>

    <!-- 
    <div class="form-group">
      <label for="exampleInputCity1"><b>End Date </b></label>
      <input type="text" class="form-control" id="renewEndDate" placeholder="" name="renewEndDate" readonly
        [(ngModel)]="renewEndDate" required>
    </div>
-->

    <div class="form-group">
      <label for="exampleInputCity1"><b>Comments</b></label>
      <input type="text" class="form-control" id="renewComment" placeholder="" name="renewComment"
        [(ngModel)]="renewComment" required>
    </div>
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-primary" (click)="sendRenewRequest()" nz-button [nzLoading]="isLoadingRenew">Submit</button>
  </div>

</nz-modal>


<!-- Cancel Request Modal  -->
<nz-modal [(nzVisible)]="isCancelVisible" nzTitle="Cancel Request" (nzOnCancel)="handleCancel()">

  <div *nzModalContent>
    <div class="form-group">
      <label for="justification"><b>Comment</b></label>
      <textarea class="form-control" id="cancelComment" name="cancelComment" [(ngModel)]="cancelComment"
        required>
      </textarea>
    </div>

  
  </div>

  <div *nzModalFooter>
    <button class="btn btn-light" (click)="handleCancel()">Cancel</button>
    <button class="btn btn-danger" (click)="cancelRequest()" [disabled]="isChangeOkLoading">Cancel Request</button>
  </div>

</nz-modal>

 <!-- View Pending Request Approval Modal  -->
 <nz-modal [(nzVisible)]="isContractpprovalModalVisible" nzTitle="Request Approvals"[nzWidth]="800" (nzOnOk)="handleCancel()" [nzCancelText]="null">

  <div *nzModalContent>
   
    <div class="table-responsive">
      <table class="table table--striped table-hover">
        <thead>
          <tr>

            <th>
              Name
            </th>
            <th>
              Designation
            </th>
            <th>
              Status
            </th>
          
            <th>
              Aproval Date
            </th>
          

          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let approval of ContractRequestApprovals">

            <td>{{approval.name}}</td>
            <td>{{approval.designation }}</td>
            <td>{{approval.status}}</td>
            <td>{{approval.approvalDate | date: 'dd/MM/yyyy'}}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

 
</nz-modal>